import React from 'react';
import { Box } from '@chakra-ui/react';

const ModernLayout = ({ children }) => {
  return (
    <Box>
      {/* Font Loading */}
      <style>
        {`
          @font-face {
            font-family: 'KanitGa';
            src: url('/fonts/KaniGa_Regular.ttf') format('truetype');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
          }
          
          @font-face {
            font-family: 'DbPenthaiX';
            src: url('/fonts/DB-PenThai-X.ttf') format('truetype');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
          }
          
          * {
            box-sizing: border-box;
          }
          
          body {
            margin: 0;
            padding: 0;
            font-family: 'DbPenthaiX', sans-serif;
            line-height: 1.6;
            color: #242424;
            background-color: #ffffff;
          }
          
          h1, h2, h3, h4, h5, h6 {
            font-family: 'KanitGa', sans-serif;
            font-weight: normal;
            margin: 0;
            padding: 0;
          }
          
          img {
            max-width: 100%;
            height: auto;
          }
          
          a {
            text-decoration: none;
            color: inherit;
          }
          
          button {
            font-family: inherit;
          }
        `}
      </style>
      {children}
    </Box>
  );
};

export default ModernLayout; 